import styled from 'styled-components';

export const DirectDealNotice = () => {
  return (
    <ContainerOuter>
      <ContainerInner>
        <NoticeSection>
          <NoticeTitle>{'안전한 직거래를 위한 구매자 주의사항'}</NoticeTitle>
          <NoticeList>
            <NoticeListItem>
              <NoticeItemTitle>{'1. 실물 확인 전 선입금 절대 금지'}</NoticeItemTitle>
              <NoticeItemContent>
                {`장비를 직접 확인하기 전, 어떤 명목으로도 송금을 요구하면 사기일 가능성이 높습니다.
                판매자가 보내는 신분증이나 서류 사진은 도용될 수 있으니 절대 신뢰하지 마세요.`}
              </NoticeItemContent>
            </NoticeListItem>
            <NoticeListItem>
              <NoticeItemTitle>{'2. 현장 방문 및 장비 상태 대면 확인 필수'}</NoticeItemTitle>
              <NoticeItemContent>
                {'반드시 현장을 방문해 기계 상태와 판매자 신원을 직접 확인하신 후 거래 대금을 지급하시기 바랍니다.'}
              </NoticeItemContent>
            </NoticeListItem>
          </NoticeList>
        </NoticeSection>
      </ContainerInner>
    </ContainerOuter>
  );
};

const ContainerOuter = styled.div`
  width: 100%;
  padding: 0px 16px 40px 16px;
`;

const ContainerInner = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 24px;
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
  border-radius: 12px;
`;

const NoticeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const NoticeTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`;

const NoticeList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
  margin: 0;
  list-style: none;
`;

const NoticeListItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NoticeItemTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`;

const NoticeItemContent = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;
